module.exports = __webpack_public_path__ + "img/image_6.ae58ee29.png";